export const SITE_DOMAIN = 'gbapp.pro'
export const SITE_ORIGIN = 'https://gbapp.pro'
export const SITE_HOME_URL = `${SITE_ORIGIN}/`
export const SITE_BRAND = 'GBApp'
export const SITE_BRAND_UPPER = 'GBAPP'
export const SITE_EMAIL = 'contact@gbapp.pro'

export const DOWNLOAD_APK_URL =
  'https://file.gbwave.in/ow/cp/prod/GB/1778653978581/GBWhatsApp_2.26.19.876_gw_07_14.apk'

export const DOWNLOAD_API_PARAMS = {
  domain: SITE_DOMAIN,
  appName: `GB_${SITE_DOMAIN}`,
}
